import {useMutation} from "@tanstack/react-query";
import {apiClient} from "../../../../lib/api-client";
import {ApiResult} from "../../../../types/ApiResult";
import {RequestCancellationParams} from "../types/RequestCancellationParams";

export const useRequestCancellation = (
	onSuccess: () => void,
	onError: (error: string) => void) => {

	const { mutate, isLoading } = useMutation({
		mutationFn: async (params: RequestCancellationParams) => {
			return await apiClient.post("retail-order/request-cancellation", params) as ApiResult;
		},
		onSuccess: async (result) => {
			if (result.isSuccess)
				onSuccess();
			else
				onError('Error when sending cancellation request: ' + result.errorMessage!);
		},
		onError(error) {
			onError(error as string);
		}
	});

	return {
		mutate, isLoading
	}
}
